<template>
  <div>
    <b-modal
      id="livness-check-modal"
      title="Alert confirmation"
      hide-footer
    >
      <h5>Are you sure you want to create liveness check?</h5>

      <b-form-textarea
        v-model="description"
        placeholder="Description"
        rows="3"
        class="mb-1"
        :disabled="submitting"
      />

      <div class="d-flex">
        <b-button
          class="mr-2"
          block
          variant="primary"
          :disabled="submitting"
          @click="submitAlert"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Yes</span>
        </b-button>
        <b-button
          block
          :disabled="submitting"
          variant="danger"
          @click="$bvModal.hide('livness-check-modal')"
        >
          No
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BButton,
  BSpinner,
  BModal,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  errorNotification,
  successNotification,
} from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'
import store from '@/store'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BFormTextarea,
  },
  props: {
    driver: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const description = ref('') // new reactive var for description

    const submitAlert = async () => {
      try {
        submitting.value = true
        await axiosIns.post('/drivers/liveness-check', {
          driver: ctx.root.$router.currentRoute.params.id,
          description: description.value, // send description here
        })
        successNotification('Success')
        ctx.root.$bvModal.hide('livness-check-modal')
        store.dispatch('driverView/fetchDriverInactivationList', {
          id: ctx.root.$router.currentRoute.params.id,
          isResolvedInactivation: false,
        })
      } catch (err) {
        const msg = err?.response?.data?.message
        errorNotification(msg || 'An error occured')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      description,
      submitAlert,
    }
  },
}
</script>
